import React from 'react';

import { ModalContext } from '../../../../contexts/ContextCreator';

import FlowShell from '../FlowShell/FlowShell';
import SelectTime from '../Steps/SelectTime/SelectTime';
import ConfirmSuccess from '../Steps/ConfirmSuccess/ConfirmSuccess';
import QuickProfile from '../Steps/QuickProfile/QuickProfile';
import EventRequirementsInput from '../Steps/EventRequirementsInput/EventRequirementsInput';
import { buildRegFlow } from './constants';
import buttonNavBox from './navButtons';

export const eventRegistrationFlowType = 'event-registration-flow';

const confirmSuccessStepProps = {
    mainText: 'You are registered for the event.',
    subtext: 'Tip: Add more details to your profile to really stand out.',
    linkUrl: '/users/profile?LAC=vre-registration&LAT=vre-registration',
    buttonText: 'Go to your profile',
};

export const EventRegistrationFlow = (props) => {
    const { generalModalProps, closeModal } = React.useContext(ModalContext);

    const {
        event,
        startStep = '',
        requiredSteps = {},
        eventPreferredTimes = [],
        setUserAsRegistered,
        toggleJobProfileSnippetComplete,
        sourceType,
    } = generalModalProps;

    const initializeOptions = {
        event,
        startStep,
        requiredSteps,
        eventPreferredTimes,
        setUserAsRegistered,
        toggleJobProfileSnippetComplete,
        sourceType,
    };

    const { flowTree, initialStep, initialFlowData } = buildRegFlow(
        initializeOptions
    );

    const vfairComponents = (
        <React.Fragment>
            <QuickProfile buttonNavBox={buttonNavBox} />
            <EventRequirementsInput />
            <SelectTime />
            <ConfirmSuccess {...confirmSuccessStepProps} />
        </React.Fragment>
    );

    const noRequirementsComponents = (
        <React.Fragment>
            <QuickProfile buttonNavBox={buttonNavBox} />
            <ConfirmSuccess {...confirmSuccessStepProps} />
        </React.Fragment>
    );

    const regFlowComponents =
        sourceType === 'vfairs' ? vfairComponents : noRequirementsComponents;

    return (
        <FlowShell
            tree={flowTree}
            initialStep={initialStep}
            initialFlowData={initialFlowData}
            closeModal={closeModal}
        >
            {regFlowComponents}
        </FlowShell>
    );
};

EventRegistrationFlow.displayName = 'EventRegistrationFlow';

export default React.memo(EventRegistrationFlow);
